import { css } from "@emotion/react";

export const messageContainer = css`
  text-align: left;
`;
